import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Moon, Salad, Activity } from 'lucide-react';
export const SolutionSection = () => {
  const pillars = [{
    icon: <Moon className="w-8 h-8 text-sage" data-id="element-276" />,
    title: 'Sincronización del Sueño',
    desc: 'Alinea los ritmos circadianos con la biología hormonal actual.'
  }, {
    icon: <Salad className="w-8 h-8 text-sage" data-id="element-277" />,
    title: 'Nutrición Antiinflamatoria',
    desc: 'Alimenta las células con lo que necesitan en esta etapa específica.'
  }, {
    icon: <Activity className="w-8 h-8 text-sage" data-id="element-278" />,
    title: 'Movimiento Inteligente',
    desc: 'Activa la energía sin generar estrés hormonal adicional.'
  }];
  return <>
      {/* The Solution: Method */}
      <Section bg="bg-sage-light/30" data-id="element-279">
        <FadeIn data-id="element-280">
          <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-281">
            <span className="text-sage font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-282">
              La Solución
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-283">
              El Método de{' '}
              <span className="text-gold italic font-normal" data-id="element-284">
                Micro-Sincronización Hormonal
              </span>
            </h2>
            <p className="text-lg md:text-xl text-brown-light leading-relaxed" data-id="element-285">
              En lugar de atacar síntomas aislados, trabaja sobre tres palancas
              simultáneas que se refuerzan entre sí.
            </p>
          </div>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto" data-id="element-286">
          {pillars.map((pillar, i) => <StaggerItem key={i} data-id="element-287">
              <div className="bg-white p-8 rounded-3xl h-full border border-cream-dark shadow-sm hover:shadow-md transition-shadow text-center" data-id="element-288">
                <div className="w-16 h-16 bg-sage-light rounded-full flex items-center justify-center mb-6 mx-auto" data-id="element-289">
                  {pillar.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-brown" data-id="element-290">
                  {pillar.title}
                </h3>
                <p className="text-brown-light leading-relaxed" data-id="element-291">
                  {pillar.desc}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn delay={0.3} data-id="element-292">
          <div className="max-w-2xl mx-auto text-center mt-16" data-id="element-293">
            <p className="text-xl md:text-2xl text-brown font-medium leading-relaxed" data-id="element-294">
              No es más esfuerzo.
            </p>
            <p className="text-xl md:text-2xl text-gold font-bold italic mt-3" data-id="element-295">
              Es el esfuerzo correcto, en el momento correcto, para el cuerpo
              correcto.
            </p>
          </div>
        </FadeIn>
      </Section>
    </>;
};